import { cn } from '@natu/utils/cn';

import {
  type BlokItem,
  type SBProps,
  type Spacing,
  DynamicRender,
  resolveStoryblokStyles,
  sbEditable,
} from '../../../../utils';
import type { BannerDecorator } from './DynamicBannerDecorator/bannerDecorators';
import { DynamicBannerDecorator } from './DynamicBannerDecorator/DynamicBannerDecorator';

interface SBBannerProps {
  decorators?: BannerDecorator;
  body?: BlokItem[];
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  pxMobile?: Spacing;
  pxTablet?: Spacing;
  pxDesktop?: Spacing;
  ptMobile?: Spacing;
  ptTablet?: Spacing;
  ptDesktop?: Spacing;
  pbMobile?: Spacing;
  pbTablet?: Spacing;
  pbDesktop?: Spacing;
}

export const SBBanner = ({ blok }: SBProps<SBBannerProps>) => {
  const {
    decorators,
    body,
    mtMobile,
    mtTablet,
    mtDesktop,
    mbMobile,
    mbTablet,
    mbDesktop,
    pxMobile,
    pxTablet,
    pxDesktop,
    ptMobile,
    ptTablet,
    ptDesktop,
    pbMobile,
    pbTablet,
    pbDesktop,
  } = blok;

  const style = {
    wrapper: resolveStoryblokStyles({
      mt: mtMobile,
      mtTablet,
      mtDesktop,
      mb: mbMobile,
      mbTablet,
      mbDesktop,
    }),
    content: resolveStoryblokStyles({
      pl: pxMobile,
      plTablet: pxTablet,
      plDesktop: pxDesktop,
      pr: pxMobile,
      prTablet: pxTablet,
      prDesktop: pxDesktop,
      pt: ptMobile,
      ptTablet,
      ptDesktop,
      pb: pbMobile,
      pbTablet,
      pbDesktop,
    }),
  };

  return (
    <section
      className={cn('relative mx-auto overflow-hidden rounded-xl md:rounded-2xl', style.wrapper)}
      {...sbEditable(blok)}
    >
      <DynamicBannerDecorator type={decorators} />
      <div className={cn('bg-primary-600 rounded-xl md:rounded-2xl', style.content)}>
        <div className="relative z-[2]">
          <DynamicRender data={body} />
        </div>
      </div>
    </section>
  );
};
